import React from 'react';

import Loading from '../../../Common/Loading';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';
import './styles/Charts.css';
import { LocationIndex } from './LocationIndex';
import { RegulationIndex } from './RegulationIndex';
import { TotalOcurrencesMedicalRegulation } from './TotalOcurrencesMedicalRegulation';

const RegulationResults = () => {
    const { isLoading } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="side-by-side-group">
                <LocationIndex />
                <RegulationIndex />
            </div>
            <div className="side-by-side-group">
                <TotalOcurrencesMedicalRegulation />
            </div>
        </>
    );
};

export default RegulationResults;
